<template>

  <modalo
    :title="$t('Invite new member')"
    type="mini"
    @hideModal="hideModal()">

    <div v-if="sending">
      <div
       v-for="(item, index) in arrResult"
       :key="index">
       {{ item.email }} <span :class="item.color">({{ item.text }})</span>
      </div>
    </div>

    <div v-if="!sending">
      <form
        id="memberInvite-form"
        v-on:submit.prevent="createMemberInvite(memberInvite)">
        <div class="form-group">
          <label>{{ $t('Emails') }}</label>
          <p class="text-muted">Informe até 50 e-mails, um por linha.</p>
          <textarea-autosize
            :placeholder="`email@domain.com\r\nemail@domain.com\r\n...`"
            v-model="memberInvite.emails"
            :min-height="100"
            :max-height="200"
            class="form-control"></textarea-autosize>
          <ValidateMessage
            v-if="!isLimiteEmails"
            :error="{ message: 'Informe até 50 emails' }" />
        </div>

        <div class="form-group">
          <label>{{ $t('Role') }}</label>
          <select-role
            v-model="memberInvite.role_id">
            </select-role>
          <ValidateMessage :error="validateErrors.role_id" />
        </div>
      </form>
    </div>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          v-if="!sending"
          type="submit"
          form="memberInvite-form"
          class="btn btn-primary"
          :disabled="!filled">{{ $t('Send') }}</button>
        <button
          v-if="sending"
          type="button"
          class="btn btn-outline-primary"
          @click="reset">{{ $t('Adicionar mais usuários') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click="hideModal()">{{ $t('Cancel') }}</button>
      </div>
    </template>

  </modalo>

</template>

<script>
import _ from 'lodash'
import SelectRole from '@/components/Fields/SelectRole'

export default {
  name: 'MemberInviteForm',
  components: {
    SelectRole
  },
  props: [
    'initMemberInvite'
  ],
  data () {
    return {
      sending: false,
      result: [],
      loading: false,
      memberInvite: this.defaultValues(this.initMemberInvite),
      validateErrors: {}
    }
  },
  computed: {
    filled () {
      return this.memberInvite.emails && this.memberInvite.role_id
    },
    emails () {
      const text = this.memberInvite.emails
      if (!text) return []
      // Regex para identificar e-mails
      const emailRegex = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g
      const emails = text.match(emailRegex)
      return emails || []
    },
    isLimiteEmails () {
      return this.emails.length <= 50
    },
    arrResult () {
      return this.result.map(item => {
        let res = {
          email: item.email,
          color: 'text-secondary',
          text: 'Enviando...'
        }
        if (item.status === 'success') {
          res.color = 'text-success'
          res.text = 'Sucesso'
        }
        if (item.status === 'error') {
          res.color = 'text-danger'
          res.text = item.error
        }
        return res
      })
    }
  },
  created () {
  },
  methods: {
    reset () {
      this.sending = false
      this.memberInvite = {
        emails: null,
        role_id: null
      }
      this.result = []
    },
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
      }, values)
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    createMemberInvite
    */
    createMemberInvite (data) {
      if (this.filled && this.isLimiteEmails) {
        this.loading = this.sending = true
        return Promise.all(this.emails.map(email => {
          const item = { email, status: 'sending', error: null }
          this.result.push(item)
          return this.$store.dispatch('createMemberInvite', {
            email,
            role_id: data.role_id
          }).then(() => {
            item.status = 'success'
          }).catch(result => {
            item.status = 'error'
            item.error = _.get(result, 'response.data.errors.email.message', 'Falhou')
            return Promise.resolve(null)
          })
        })).then(() => {
          this.loading = false
          this.$emit('saved')
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Member/MemberInviteForm.vue